import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ArrowDownIcon } from '../../../../../../../icons/ArrowDownIcon';
import { theme } from '../../../../../../common/styles/theme';
import { Text } from '../../../../../../common/components/Text/Text';

// Book settings above page 1, collapsed by default; later pages open them from the reader's ⚙.
export const BookSettingsAccordion: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [open, setOpen] = React.useState(false);

	return (
		<Accordion
			disableGutters
			elevation={0}
			expanded={open}
			onChange={() => setOpen(!open)}
			sx={{
				mb: 3,
				background: theme.palette.common.white,
				border: `2px solid ${theme.palette.grey[200]}`,
				overflow: 'hidden',
				'&, &:first-of-type, &:last-of-type': { borderRadius: theme.spacing(1) },
				'&:before': { display: 'none' },
				'.MuiAccordionSummary-root': {
					px: 2,
					minHeight: theme.spacing(6),
					background: theme.palette.grey[200],
					'&:hover': { background: theme.palette.grey[300] },
				},
				'.MuiAccordionSummary-content': { m: 0 },
				'.MuiAccordionDetails-root': { p: 2 },
			}}
		>
			<AccordionSummary expandIcon={<ArrowDownIcon />}>
				<Text variant={'subtitle2'} fontWeight={600} sx={{ lineHeight: 1.2 }}>Book settings</Text>
			</AccordionSummary>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
};
